<template>
	<span
		:title="characteristic.description && (!descriptionConfig || !descriptionConfig.inline)
			? characteristic.description
			: undefined"
		v-b-tooltip="{html: true, boundary: 'window'}"
	>
		<span class="characteristic-select-inline--item-label-label">
			<Label
				:characteristic="characteristic"
				:label-type="labelType"
				:highlight-words="highlightWords"
			/>
		</span>
		<span v-if="hasIcon" class="characteristic-select-inline--label-icon">
			<img
				:src="iconPath + '/' + characteristic.naturalId + '.svg'"
				:alt="label"
			/>
		</span>
		<span
			v-if="characteristic.description"
			:class="{
				 'characteristic-select-inline--item-description': true,
				 'characteristic-select-inline--item-description-html': isDescriptionHtml,
			}"
		>
			<template v-if="descriptionConfig && descriptionConfig.inline">
				<span v-if="isDescriptionHtml" v-html="characteristic.description"/>
				<template v-else>{{ characteristic.description | stripTags }}</template>
			</template>
			<Icon v-else icon="info"/>
		</span>
	</span>
</template>

<script>
import Label from "@/vue/characteristic/Label";
import Icon from "@/vue/icon/Icon";
import {get} from "@/helper/characteristic/Label";

export default {

	components: {
		Icon,
		Label,
	},

	props: {
		characteristic: {
			type: Object,
			required: true,
		},
		hasIcon: {
			type: Boolean,
			required: true,
		},
		labelType: {
			type: String,
			required: false,
		},
		iconPath: {
			type: String,
			required: false,
		},
		descriptionConfig: {
			type: Object,
			required: false,
		},
		highlightWords: {
			type: Array,
			required: false
		}
	},

	computed: {
		label ()
		{
			return get(this.characteristic, this.labelType);
		},
		isDescriptionHtml ()
		{
			return this.descriptionConfig?.html === true;
		}
	}
}
</script>
